import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { px2rem } from '../../helpers/rem.mjs';
import { buttonWidthMap, buttonPaddingMap, buttonHeightMap, buttonFontStyleMap } from './data.mjs';
import '../../components/loading/index.mjs';
import { MEDIA_QUERY } from '../../constants/responsive.mjs';
import LoadingIcon from '../../components/loading/icon/index.mjs';

var buttonCSS = css(["min-width:", ";padding:0 ", ";height:", ";", ";border-radius:", ";transition:opacity 300ms;", " ", " @media ", "{&:hover{opacity:0.6;}}"], function (props) {
  return px2rem(buttonWidthMap.get(props.size));
}, function (props) {
  return px2rem(buttonPaddingMap.get(props.size));
}, function (props) {
  return px2rem(buttonHeightMap.get(props.size));
}, function (props) {
  return buttonFontStyleMap.get(props.size);
}, px2rem(4), function (props) {
  return !props.waiting ? css(["&:disabled{opacity:0.4;cursor:inherit;}"]) : css(["cursor:wait;&:hover{opacity:unset;}"]);
}, function (props) {
  return props.isFullWidth && css(["width:100%;"]);
}, MEDIA_QUERY.EXCEPT_MOBILE);
var loaderStyle = css(["top:0;"]);
var ButtonStyled = styled.button.attrs(function (props) {
  return {
    disabled: props.disabled || props.waiting
  };
}).withConfig({
  displayName: "ButtonStyled",
  componentId: "sc-1xtgskx-0"
})(["", ";"], buttonCSS);
var BaseButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var buttonChildren = props.children,
    loaderColor = props.loaderColor;
  var children = props.waiting ? jsx(LoadingIcon, {
    color: loaderColor,
    overrideStyle: loaderStyle
  }) : buttonChildren;
  return jsx(ButtonStyled, Object.assign({}, props, {
    ref: ref,
    children: children
  }));
});

export { BaseButton };
